import React from 'react'
import { RESTRICTED_DETAIL_SENTENCE } from 'enrollment-platform/rbac/restricted-detail-sentence'

export { RESTRICTED_DETAIL_SENTENCE }

type RestrictedWaiterError = {
  response?: {
    status?: number
    data?: unknown
  }
} | null

export function restrictedDetailMessage(
  error?: RestrictedWaiterError
): string | null {
  if (error?.response?.status === 403) return RESTRICTED_DETAIL_SENTENCE
  return null
}

export default function ApplicationDetailRestricted() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        padding: 48,
      }}
    >
      <div
        style={{
          maxWidth: 640,
          padding: '40px 48px',
          textAlign: 'center',
          background: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: 8,
        }}
      >
        <p
          style={{
            margin: 0,
            color: '#003146',
            fontSize: '28px',
            fontWeight: 600,
            lineHeight: 1.35,
            textAlign: 'center',
          }}
        >
          {RESTRICTED_DETAIL_SENTENCE}
        </p>
      </div>
    </div>
  )
}
